import { render, staticRenderFns } from "./yqgl.vue?vue&type=template&id=6ef82088&scoped=true&"
import script from "./yqgl.vue?vue&type=script&lang=js&"
export * from "./yqgl.vue?vue&type=script&lang=js&"
import style0 from "./yqgl.vue?vue&type=style&index=0&id=6ef82088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef82088",
  null
  
)

export default component.exports